import { FC } from 'react'
import { Slider, TextFieldProps } from '@mui/material'
import { useField, useFormikContext } from 'formik'
import _ from 'lodash'

interface IProps {
  fieldProps: TextFieldProps
  valueSelector?: string
  sx?: any
  onChange?: any
  disabled?: boolean
  min?: number
  max?: number
  step?: number
}


const SliderField: FC<IProps> = ({ 
    fieldProps,
    valueSelector, 
    onChange, 
    sx = {}, 
    disabled, 
    min,
    max, 
    step
  }) => {
  const [field] = useField(fieldProps.name)
  const { setFieldValue } = useFormikContext()

  const value = valueSelector ? field.value[valueSelector] : field.value

  
  return (
      <>
        <label>{fieldProps.label}</label>
        <Slider
           min={min}
          max={max}
          step={step}
          value={value || min}
          valueLabelDisplay="auto"
          marks={ _.range(min,max+1,step*2).map(n => { 
            return {
              value: n,
              label: n.toString(),
              }
            }) 
          }
          disabled={disabled}
          sx={sx}
          onChange={(event, value) => {

            const newValue = valueSelector ? {
              ...field.value,
              [valueSelector]: value,
            } : value

            setFieldValue(fieldProps.name, newValue)
      
            if (onChange) onChange(value)
          }}
        />
      </>
  )
}
export default SliderField
